import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Seo from '../utils/Seo';
import '../css/contact.css';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', comment: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Enviando...');
    
    // Create FormData object for better compatibility
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('email', form.email);
    formData.append('comment', form.comment);
    
    try {
      const res = await fetch('/api/send-email.php', {
        method: 'POST',
        body: formData, // Using FormData instead of JSON
      });
      
      const result = await res.text();
      
      if (res.ok && result === 'success') {
        setStatus('¡Mensaje enviado!');
        setForm({ name: '', email: '', comment: '' });
      } else {
        setStatus('Error al enviar. Intenta de nuevo.');
        console.error('Server response:', result);
      }
    } catch (error) {
      setStatus('Error al enviar. Intenta de nuevo.');
      console.error('Fetch error:', error);
    }
  };
    
  const location = useLocation();

  return (
    <div id='contact' className="container mt-5 mainMargin">
        <Seo
            title="Contacta a Noche de Muertos | Día de la Vida"
            description="Queremos escucharte en Día de Muertos."
        />
        <div className="row">
          <div className="col-md-12">
            <h2>Contacto</h2>
          </div>
          <div className="col-md-6 order-2 order-md-1">
            <div style={{maxWidth: 500}}>
              <p><b>Llena el formulario con tus datos y nos pondremos en contacto contigo a la brevedad.</b></p>
            </div>
            <form onSubmit={handleSubmit} style={{ maxWidth: 500 }}>
              {/* Honeypot field for spam protection */}
              <div style={{ opacity: 0, position: 'absolute', left: '-5000px' }}>
                <label htmlFor="website">Website</label>
                <input 
                  type="text" 
                  id="website" 
                  name="website" 
                  tabIndex="-1"
                  autoComplete="off"
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Nombre</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  required
                  value={form.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  required
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Comentario</label>
                <textarea
                  name="comment"
                  className="form-control"
                  required
                  rows={4}
                  value={form.comment}
                  onChange={handleChange}
                />
              </div>
              <button type="submit" className="btn Galindo">Enviar</button>
              {status && <div className="mt-3">{status}</div>}
            </form>
          </div>
          <div className="col-md-6 order-1 order-md-2" style={{textAlign: 'center'}}>
            <p>Para nosotros es muy importante tu opinión acerca del libro, sus personajes y cuánto te gustó. ¡Nos encantará escuchar de ti!</p>
            <p>Tambien puedes contactarnos para la venta del libro, promocionales o eventos</p>
            <p><b>¡Esta historia apenas comienza!</b></p>
            <img src="https://www.diadelavida.com/images/chapters/deco_capitulo4.png" className='img-fluid' style={{marginBottom: 40}} alt="Contacta a Día de la Vida" />
          </div>
      </div>
    </div>
  );
}